import { createTheme } from "@mantine/core";
export const theme = createTheme({
  /* Put your mantine theme override here */
  fontFamily: `"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"`,
  fontFamilyMonospace: `"Plus Jakarta Sans",-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"`,
  defaultRadius: "md",
  primaryColor: 'manta',
  colors: {
    'manta': ['#003554', '#003554', '#003554', '#003554', '#003554', '#003554', '#003554', '#003554', '#003554', '#003554']
  },
  components: {
    Button: {
      styles: () => ({
        root: {
          fontWeight: 400,
        },
      }),
    },
  }
});
